import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import { helperTextStyles } from './helperTextStyles';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';

export interface IHelperText {
  text: string;
}

export const HelperText = ({ text }: IHelperText) => {
  const theme = useTheme();
  const classes = helperTextStyles(theme);

  return (
    <Tooltip
      title={<Typography variant={'subtitle2'}>{text}</Typography>}
      placement='top-start'
    >
      <IconButton sx={classes.helpIcon} color='secondary'>
        <HelpIcon />
      </IconButton>
    </Tooltip>
  );
};
